export default {"src":"/_next/static/media/logo-light-mode.328d9ecd.svg","height":26,"width":211};